<template>
  <div class="container-fluid">
    <div class="row mb-5">
      <div class="col">
        <h2>Formulaire de vote par correspondance</h2>
      </div>
    </div>
    <div class="row">
      <div class="col border border-dark p-2">
        Objet : Assemblée générale des copropriétaires du (des) immeuble(s) sis
        <!-- eslint-disable-next-line prettier/prettier -->
        <div class="text-br-line font-weight-bold my-2">{{ building.address }}</div>
        Date :
        <span
          v-if="meeting.allowed_modalities.physical || meeting.allowed_modalities.video"
          class="font-weight-bold"
        >
          {{
            $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY [à] HH[h]mm")
          }}
        </span>
        <span v-else class="font-weight-bold">
          {{ $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY") }}
        </span>
        <div v-if="meeting.allowed_modalities.physical">
          Lieu :
          <div>
            <!-- eslint-disable-next-line prettier/prettier -->
            <!-- eslint-disable vue/no-v-html -->
            <div
              v-if="meeting.address"
              class="text-br-line font-weight-bold mb-3"
              v-html="meeting.address"
            ></div>
            <div v-else class="text-danger">pas d'adresse définie</div>
          </div>
        </div>
        <div
          v-if="
            !meeting.allowed_modalities.physical &&
            !meeting.allowed_modalities.video &&
            meeting.allowed_modalities.correspondence
          "
        >
          Exclusivement par correspondance.
        </div>
        <div v-if="meeting.allowed_modalities.video">
          Videoconférence :
          <a
            v-if="!meeting.external_video_solution"
            class="text-dark font-weight-bold"
            href="https://participant.domeo-ag.com"
          >
            https://participant.domeo-ag.com
          </a>
          <a v-else class="text-dark font-weight-bold" :href="meeting.external_video_solution">{{
            meeting.external_video_solution
          }}</a>
        </div>
      </div>
    </div>
    <div class="row my-4">
      <div class="offset-5">
        Ce formulaire doit être adressé à :
        <div
          class="font-weight-bold mt-3"
          style="white-space: pre-line;"
          v-html="pdfContactDetails"
        ></div>
        <div class="font-weight-bold">
          {{ agencyEmail }}
        </div>
        <div class="mt-4">
          Avant la date limite de réception
          <span class="font-weight-bold">{{
            $moment(toLocalTime(meeting.last_reception_date))
              .locale("fr")
              .format("[le] DD MMMM YYYY")
          }}</span>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col">
        Je soussigné(e) : <span class="font-weight-bold">{{ personName }}</span>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-2">
        domicilié (e) au :
      </div>
      <div class="col-10 font-weight-bold">
        <span v-if="addresses.line1">{{ addresses.line1 }} <br /></span>
        <span v-if="addresses.line2">{{ addresses.line2 }} <br /></span>
        <span v-if="addresses.line3">{{ addresses.line3 }} <br /></span>
        <span v-if="addresses.line4">{{ addresses.line4 }} <br /></span>
        <span v-if="addresses.line5">{{ addresses.line5 }} </span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        après avoir pris connaissance de l'ordre du jour et des documents annexés à la convocation
        ou mis a disposition sur le site en ligne sécurisé de la copropriété.
      </div>
    </div>
    <div class="row my-4">
      <div class="col font-weight-bold">
        Souhaite émettre sur chacune des résolutions proposées à l'assemblée générale des
        copropriétaires convoquée
        <span
          v-if="meeting.allowed_modalities.physical || meeting.allowed_modalities.video"
          class="font-weight-bold"
        >
          {{
            $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY [à] HH[h]mm")
          }}
        </span>
        <span v-else class="font-weight-bold">
          {{ $moment(toLocalTime(meeting.date)).locale("fr").format("[le] DD MMMM YYYY") }}
        </span>
        <span
          v-if="
            !meeting.allowed_modalities.physical &&
            !meeting.allowed_modalities.video &&
            meeting.allowed_modalities.correspondence
          "
        >
          , exclusivement par correspondance
        </span>
        le vote exprimé dans le tableau ci-joint, qui s'affiche à partir de la page 2.
        <!-- TODO: Find number of pages of the table resolutions -->
        <!-- ({{ pages }} page(s)). -->
      </div>
    </div>
    <div class="row font-weight-bold mt-5">
      <div class="col text-right">
        Fait à : _____________________________ le : ___________________________
      </div>
    </div>
    <div class="row mb-5">
      <div class="col text-right">
        (Signature du copropriétaire, de l'associé ou du mandataire commun)
      </div>
    </div>
    <div class="row mt-5">
      <div class="col text-right font-weight-bold font-italic mt-5">Tournez la page SVP</div>
    </div>

    <div class="new-page"></div>

    <div class="row">
      <div class="col">
        <h4>Ordre du jour</h4>
      </div>
    </div>
    <table id="resolutionsTable" class="table">
      <thead>
        <!-- Will print at the top of every page -->
        <tr class="border d-flex">
          <th
            class="table-fixed-col-nr font-weight-bold small border-right border-left col-1"
            scope="col"
          >
            N°
          </th>
          <th class="col-7 font-weight-bold small border-right border-left" scope="col">
            RÉSOLUTION
          </th>
          <th class="col-1 font-weight-bold small border-right border-left" scope="col">POUR*</th>
          <th class="col-1 font-weight-bold small border-right border-left" scope="col">CONTRE*</th>
          <th class="col-2 font-weight-bold small border-right border-left" scope="col">
            ABSTENTION*
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="resolution in extractResolutions()" :key="resolution.id" class="border d-flex">
          <td
            class="table-fixed-col-nr align-middle border-right border-left col-1"
            :style="getCustomStyleBackground(resolution)"
          >
            {{ resolution.resolution_number }}
          </td>
          <td class="col-7 border-right border-left" :style="getCustomStyleBackground(resolution)">
            <div v-if="resolution.dummy_resolution_text" class="font-italic">
              <small>{{ resolution.dummy_resolution_text }}</small>
            </div>
            {{ resolution.name }} <br />
            <span
              v-if="
                !resolution.has_children &&
                resolution.majority &&
                resolution.majority_id != defaultSansVoteMajorityId
              "
              class="font-italic mb-2"
            >
              Majorité : {{ resolution.majority.name }}
              <span v-if="resolution.voting_category">
                &nbsp; - Clé de vote : {{ resolution.voting_category.name }}
              </span>
            </span>
            <div v-if="!resolution.majority && !resolution.has_children" class="text-danger">
              majorité non définie
            </div>
            <div
              v-if="
                !resolution.has_children &&
                resolution.majority &&
                resolution.majority_id == defaultSansVoteMajorityId
              "
            >
              {{ resolution.majority.name }}
            </div>
          </td>
          <td
            class="col-1 border-right border-left"
            :style="getCustomStyleBackground(resolution)"
          ></td>
          <td
            class="col-1 border-right border-left"
            :style="getCustomStyleBackground(resolution)"
          ></td>
          <td
            class="col-2 border-right border-left"
            :style="getCustomStyleBackground(resolution)"
          ></td>
        </tr>
      </tbody>
      <tfoot>
        <!-- Will print at the bottom of every page -->
        <tr class="border d-flex">
          <td class="col-8 mb-4 border-right-0">
            <div class="font-weight-bold">Signature**</div>
            <div class="font-italic small">
              (du copropriétaire, de l'associé ou du mandataire commun)
            </div>
          </td>
          <th class="col mb-4">
            * cochez la case correspondante
          </th>
        </tr>
      </tfoot>
    </table>
    <div class="row no-break">
      <div class="col">
        <div>* Cocher la case correspondante</div>
        <div>
          ** Si plusieurs pages de vote, parapher les pages intermédiaires et signer la dernière
          page
        </div>
        <div class="text-right font-weight-bold font-italic mt-4">Tournez la page SVP</div>
      </div>
    </div>

    <div class="new-page"></div>

    <div class="row mb-5">
      <div class="col text-center">
        <h4>{{ "Rappel des dispositions légales et réglementaires".toLocaleUpperCase() }}</h4>
      </div>
    </div>
    <div class="row">
      <div class="col">
        Il s’agit du formulaire prévu par l’<span class="font-weight-bold"
          >alinéa 2 de l’article 17-1 A de la loi n° 65-557 du 10 juillet 1965</span
        >
        qui précise que :
        <span class="font-italic">
          « Les copropriétaires peuvent, par ailleurs, voter par correspondance avant la tenue de
          l'assemblée générale, au moyen d'un formulaire établi conformément à un modèle fixé par
          arrêté. Si la résolution objet du vote par correspondance est amendée en cours d'assemblée
          générale, le votant par correspondance ayant voté favorablement est assimilé à un
          copropriétaire défaillant pour cette résolution. »
        </span>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col">
        Ce formulaire est régi par les articles 9 alinéa 2, 9 bis, 14, 14-1 et 17 alinéa 3 du décret
        n° 67-223 du 17 mars 1967 modifié pris pour l'application de la loi n° 65-557 du 10 juillet
        1965 fixant le statut de la copropriété des immeubles bâtis, selon lesquels :
        <div class="font-weight-bold mt-3">Alinéa 2 de l'article 9 :</div>
        <div class="font-italic">
          « Le formulaire de vote par correspondance mentionné au deuxième alinéa de l'article 17-1
          A est joint à la convocation. »
        </div>
        <div class="font-weight-bold mt-3">Alinéa 1 à 4 de l'article 14 :</div>
        <div class="font-italic">
          « Il est tenu une feuille de présence, pouvant comporter plusieurs feuillets, qui indique
          les nom et domicile de chaque copropriétaire ou associé :
          <ul>
            <li>
              Présent physiquement ou représente
            </li>
            <li>
              Participant à l'assemblée générale par visioconférence, par audioconférence ou par un
              autre moyen de communication électronique ;
            </li>
            <li>
              Ayant voté par correspondance avec mention de la date de réception du formulaire par
              le syndic »
            </li>
          </ul>
        </div>
        <div class="font-weight-bold mt-3">Article 14-1 :</div>
        <div class="font-italic">
          « Le formulaire de vote par correspondance n'est pas pris en compte lorsque le
          copropriétaire, l'associé ou leur mandataire est présent à l'assemblée générale. »
        </div>
        <div class="font-weight-bold mt-3">Alinéa 3 de l'article 17 :</div>
        <div class="font-italic">
          « Le proces-verbal comporte, sous l'intitulé de chaque question inscrite à l'ordre du
          jour, le résultat du vote. Il précise les noms et nombre de voix des copropriétaires ou
          associés qui se sont opposés à la décision, qui se sont abstenus, ou qui sont assimilés à
          un copropriétaire défaillant en application du deuxième alinéa de l'article 17-1 A de la
          loi du 10 juillet 1965. »
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defaultSansVoteMajorityId } from "@/constants/default.js";

export default {
  props: [
    "meeting",
    "mandate",
    "resolutions",
    "building",
    "countries",
    "majorities",
    "pdfContactDetails",
    "agencyEmail",
  ],
  data() {
    return {
      defaultSansVoteMajorityId,
      addresses: {},
      personName: "",
    };
  },
  created() {
    this.personName = this.getPersonNameAndGender({}, this.mandate.building_owner);
    this.extractAddresses();
    this.extractResolutions();
  },
  methods: {
    extractAddresses() {
      // TODO: Refactor this code
      // This could be handeled in some method to get out correct address
      let line1 = this.mandate.building_owner.complement;
      let line2 = this.mandate.building_owner.complement2;
      let line3 = this.mandate.building_owner.address;
      let line4 = "";
      let line5 = "";
      if (this.mandate.building_owner.zipcode) {
        line5 += this.mandate.building_owner.zipcode;
      }
      if (this.mandate.building_owner.city) {
        line5 += ", " + this.mandate.building_owner.city;
      }
      if (this.mandate.building_owner.country) {
        line5 += ", " + this.getCountryName(this.mandate.building_owner.country);
      }
      this.addresses = {
        line1,
        line2,
        line3,
        line4,
        line5,
      };
    },
    extractResolutions() {
      let orderedResolutions = [];
      let sortedResolutions = this.$_.sortBy(this.resolutions, resolution => {
        return resolution.position;
      });
      sortedResolutions.forEach(resolution => {
        if (resolution.parent_resolution_id == null) {
          let childrenResolutions = this.$_.filter(sortedResolutions, item => {
            return item.parent_resolution_id == resolution.id;
          });
          resolution.resolution_number = resolution.position;
          resolution["has_children"] = childrenResolutions.length > 0 ? true : false;

          orderedResolutions.push(resolution);

          let revoteResolution = this.getRevoteOption(resolution, resolution.has_children);
          orderedResolutions = orderedResolutions.concat(revoteResolution);

          if (childrenResolutions.length > 0) {
            childrenResolutions.forEach(chResolution => {
              chResolution.resolution_number =
                resolution.resolution_number.toString() + "." + chResolution.position.toString();

              orderedResolutions.push(chResolution);

              revoteResolution = this.getRevoteOption(chResolution);
              orderedResolutions = orderedResolutions.concat(revoteResolution);
            });
          }
        }
      });
      return orderedResolutions;
    },
    getCountryName(countryCode) {
      let foundCountry = this.$_.find(this.countries, country => {
        return country.countryCode == countryCode.toUpperCase();
      });
      if (foundCountry) {
        return foundCountry.countryName;
      } else {
        return "";
      }
    },
    getCustomStyleBackground(resolution) {
      if (this.parentChildrenResolutions(resolution).length > 0) {
        return "background-color: lightgrey !important;";
      } else if (resolution.majority_id == this.defaultSansVoteMajorityId) {
        return "background-color: darkgrey !important;";
      } else if (this.getTantiemes(resolution) == 0) {
        return "background-color: darkgrey !important;";
      } else {
        return "";
      }
    },
    // HACK Do this in order to prevent sometimes to not color in lightgrey the parent with childrens: DEV-4012
    parentChildrenResolutions(resolution) {
      return this.$_.filter(this.resolutions, item => {
        return resolution.id && item.parent_resolution_id == resolution.id;
      });
    },
    getRevoteMajority(majority_id) {
      let majority = this.$_.find(this.majorities, item => {
        return item.id == majority_id;
      });
      if (majority && majority.majority_conditions && majority.majority_conditions.revote) {
        return this.$_.find(this.majorities, item => {
          return item.id == majority.majority_conditions.revoteMajority;
        });
      }
      return null;
    },
    getDummyResolution(resolution, revoteMajority) {
      return {
        name: resolution.name,
        resolution_number: resolution.resolution_number,
        majority: revoteMajority,
        majority_id: revoteMajority.id,
        voting_category: resolution.voting_category,
        voting_category_id: resolution.voting_category_id,
        children_resolutions: resolution.children_resolutions,
        dummy_resolution_text: "Choix en cas de revote avec une autre majorité",
      };
    },
    getRevoteOption(resolution, hasChildren = false) {
      let revoteMajority = this.getRevoteMajority(resolution.majority_id);
      if (revoteMajority && !hasChildren) {
        return [this.getDummyResolution(resolution, revoteMajority)];
      }
      return [];
    },
    getTantiemes(resolution) {
      let tantiemes = 0;
      for (const bl of this.mandate.building_owner.building_owner_building_lots) {
        for (const bovr of bl.building_owner_voting_rights) {
          if (bovr.voting_category_id && bovr.voting_category_id == resolution.voting_category_id)
            tantiemes += bovr.parts;
        }
      }
      return tantiemes;
    },
  },
};
</script>
